import { render, staticRenderFns } from "./ColumnChartCompliance.vue?vue&type=template&id=32354d86"
import script from "./ColumnChartCompliance.vue?vue&type=script&lang=js"
export * from "./ColumnChartCompliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports